import React from "react";
import { useSelector } from "react-redux";
import Iframe from "react-iframe";

const KeyNotePage = (props) => {
  const { page, src } = props;
  const { currentPage, version } = useSelector(
    (state) => state.navigationReducer
  );
  const pageState = useSelector(
    (state) => state.navigationReducer.pageStates[page]
  );

  const {
    loaded,
    played,
    playing,
    ended,
    hasVideo,
    playedVideo,
    createdVideo,
  } = pageState || {};
  const pageFrame = document.getElementById(`iFrame_${page}`);

  // console.log(`Processing page ${page}`, currentPage, pageState);

  if (loaded && pageFrame && pageFrame.contentWindow) {
    if (hasVideo) {
      if (page === currentPage && !createdVideo && !playing)
        pageFrame.contentWindow.dispatchEvent(
          new CustomEvent("ReadyToPlay", { detail: { autoplay: !playedVideo } })
        );
      if (page !== currentPage)
        pageFrame.contentWindow.dispatchEvent(
          new CustomEvent("PauseVideo", { detail: {} })
        );
    } else if (page === currentPage && !(playing || played))
      pageFrame.contentWindow.dispatchEvent(
        new CustomEvent("ReadyToPlay", { detail: {} })
      );
    else if (played && !ended) {
      pageFrame.contentWindow.dispatchEvent(
        new CustomEvent("Reloaded", { detail: {} })
      );
    }
  }

  return (
    <Iframe
      url={`/web_sense/${src}?v=${version}`}
      id={`iFrame_${page}`}
      key={`iFrame${page}`}
      width="100%"
      height="100%"
      className={page === currentPage ? "current" : "next"}
      display="initial"
      position="fixed"
      allow="autoplay"
    />
  );
};

export default KeyNotePage;
